import * as Actions from "../action/TemplateAction";

const initialState = {
  templateData: null,
  categoryList: [],
};

const TemplateReducer = (state = initialState, action) => {
  switch (action?.type) {
    case Actions.UPDATE_TE_DATA: {
      return { ...state, templateData: action.payload };
    }
    case Actions.UPDATE_CATEGORY_DATA: {
      return { ...state, categoryList: action.payload };
    }
    case Actions.GET_TEMPLATE_LIST: {
      return { ...state, templateList: action.payload };
    }
    case Actions.ENABLE_GLOBAL_RATING: {
      if (!state.templateList) return state;
      return { ...state, templateList: { ...state.templateList, is_global_rating_enabled: action.payload } };
    }
    case Actions.GET_RATINGS_LIST: {
      // fetchCall hands error responses to the same callback, so a failed refetch must not replace a good cached pool.
      if (!Array.isArray(action.payload?.data)) return state;
      return { ...state, ratingsList: action.payload };
    }
    case Actions.REORDER_GLOBAL_RATINGS: {
      const existing = state.ratingsList?.data;
      if (!Array.isArray(existing)) return state;
      const order = action.payload.map(String);
      const byId = new Map(existing.map((r) => [String(r.id), r]));
      const reordered = order.map((id) => byId.get(id)).filter(Boolean);
      const rest = existing.filter((r) => !order.includes(String(r.id)));
      return { ...state, ratingsList: { ...state.ratingsList, data: [...reordered, ...rest] } };
    }
    default: {
      return state;
    }
  }
};

export default TemplateReducer;
